export { fetchTFExtensions } from './trusted-fetch-extensions';
